import React from 'react';
import { UserProvider, ModalProvider, ApiProvider } from 'hooks';
import {
    BrowserRouter as Router,
    Routes,
    Route,
    Navigate,
    useLocation,
} from 'react-router-dom';
import ChannelRouter from './pages/channel/[channelId]/ChannelRouter';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Layout from './components/common/Layout';
import { WebStorageStateStore } from 'oidc-client-ts';
import awsconfig, { userPoolEndpoint } from './aws-config';
import { AuthProvider as ReactAuthProvider } from 'react-oidc-context';
import Cookies from 'universal-cookie';
import { create } from 'apis';
const bluechip_studio_version = import.meta.env.VITE_VERSION_RELEASE;
const queryClient = new QueryClient();
function App() {
    console.debug('version', bluechip_studio_version);
    return (
        <ReactAuthProvider
            userStore={new WebStorageStateStore({ store: window.localStorage })}
            onSigninCallback={() => {
                //  Here you can remove the code and state parameters from the url when you are redirected from the authorize page.
                window.history.replaceState(
                    {},
                    document.title,
                    window.location.pathname,
                );
            }}
            {...awsconfig}
        >
            <Router>
                <QueryClientProvider client={queryClient}>
                    <ApiProvider api={create()}>
                        <UserProvider>
                            <ModalProvider>
                                <Layout>
                                    <Routes>
                                        <Route
                                            path="/"
                                            element={
                                                <Navigate
                                                    replace
                                                    to="/create"
                                                />
                                            }
                                        />
                                        <Route
                                            path="/bluechip"
                                            element={
                                                <Redirect url="https://www.bluechip.link" />
                                            }
                                        />
                                        <Route
                                            path="/create"
                                            element={<div>hi</div>}
                                        />
                                        <Route
                                            path="/channel/:username/home"
                                            element={
                                                <Redirect url="https://www.bluechip.link" />
                                            }
                                        />
                                        <Route
                                            path="/create/channel/*"
                                            element={<ChannelRouter />}
                                        />
                                        <Route
                                            path="/logout"
                                            element={<Logout />}
                                        />
                                    </Routes>
                                </Layout>
                            </ModalProvider>
                        </UserProvider>
                    </ApiProvider>
                </QueryClientProvider>
            </Router>
        </ReactAuthProvider>
    );
}

const Redirect: React.FC<{ url: string }> = (props) => {
    const location = useLocation();
    window.location.href = `${props.url}${location.pathname}`;
    return null;
};

const Logout: React.FC = () => {
    const stores = new WebStorageStateStore({ store: window.localStorage });
    const signOutRedirect = async () => {
        const clientId = awsconfig.client_id;
        const cookies = new Cookies();
        cookies.remove('access_token');
        const res = await stores.getAllKeys();
        for (let i = 0; i < res.length; i++) await stores.remove(res[i]);
        const logoutUri = awsconfig.redirect_uri;
        const cognitoDomain = userPoolEndpoint;
        window.location.href = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(
            logoutUri,
        )}`;
    };
    signOutRedirect();
    return <></>;
};

export default App;
